// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"is_a bii_tr","LeftMenu__link":"is_b bii_vt bii_a bii_rc","LeftMenu__link__icon":"is_c"};